/* Impression SCDM - fichiers clients.

   Ce que les gens envoient vraiment : PDF et AI en premier (c est ce que sort
   un graphiste), puis JPEG et PNG. On accepte tout ca, plus EPS, SVG, PSD et
   TIFF. Le fichier est joint a la commande dans TOUS les cas ; seul l apercu
   change selon le type :

     - PNG, JPG, WEBP, GIF, BMP, SVG : apercu direct
     - PDF et AI                     : premiere page rendue avec pdf.js
     - EPS, PS, PSD, TIFF            : pas d apercu possible dans un navigateur,
                                       on affiche une fiche et l epreuve fait foi

   Un .ai enregistre avec la compatibilite PDF (le reglage par defaut d Adobe
   Illustrator) s ouvre avec pdf.js. Sinon on bascule sur la fiche.

   POURQUOI PAS DE WORKER : mesure sur le site, le worker de pdf.js demarre
   bien mais la poignee de main ne se termine jamais et l apercu reste bloque.
   Sur le fil principal, le meme fichier s ouvre en ~200 ms. Nos fichiers sont
   petits et on ne rend qu une page : le fil principal suffit largement.
   Un chronometre coupe court de toute facon si ca traine. */
window.SCDM_FICHIERS = {
  MAX_MO: 20,                       /* limite de Shopify pour un fichier joint */
  DELAI_MS: 15000,                  /* au-dela, on abandonne l apercu proprement */
  IMAGE:  /\.(png|jpe?g|webp|gif|bmp)$/i,
  SVG:    /\.svg$/i,
  PDF:    /\.(pdf|ai)$/i,
  ACCEPTE: /\.(png|jpe?g|webp|gif|bmp|svg|pdf|ai|eps|ps|psd|tiff?)$/i,

  MSG_TYPE: 'Ce type de fichier n’est pas accepté. Envoyez un <b>PDF</b>, <b>AI</b>, <b>EPS</b>, <b>SVG</b>, <b>PNG</b> ou <b>JPG</b>.',
  MSG_TAILLE: 'Fichier trop lourd — maximum 20 Mo. Compressez-le, ou passez par la page <a href="/pages/soumission">Demander une soumission</a>.',
  MSG_SANS_APERCU: 'Fichier reçu et joint à votre commande. On ne peut pas l’afficher ici, mais vous verrez le rendu sur l’épreuve avant impression.',
  MSG_PDF_ILLISIBLE: 'Fichier reçu et joint à votre commande. On n’a pas réussi à en faire un aperçu ici ; le rendu vous sera envoyé sur l’épreuve.',

  PDFJS: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js',

  _lib: null,

  lib: function () {
    var S = this;
    if (S._lib) return S._lib;
    S._lib = new Promise(function (res, rej) {
      function pret() {
        if (!window.pdfjsLib) return rej(new Error('pdfjs absent'));
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = '';
        res(window.pdfjsLib);
      }
      if (window.pdfjsLib) return pret();
      var s = document.createElement('script');
      s.src = S.PDFJS;
      s.onload = pret;
      s.onerror = function () { rej(new Error('chargement pdfjs')); };
      document.head.appendChild(s);
    });
    return S._lib;
  },

  /* Rend la premiere page en PNG. Resout avec une data URL, ou rejette. */
  rendrePdf: function (file) {
    var S = this;
    var travail = S.lib().then(function (lib) {
      return file.arrayBuffer().then(function (buf) {
        return lib.getDocument({ data: buf, disableWorker: true, isEvalSupported: false }).promise;
      });
    }).then(function (doc) {
      return doc.getPage(1);
    }).then(function (page) {
      var vp = page.getViewport({ scale: 1 });
      var ech = Math.min(1400 / vp.width, 1400 / vp.height, 3);
      var v = page.getViewport({ scale: ech });
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.ceil(v.width));
      c.height = Math.max(1, Math.ceil(v.height));
      var cx = c.getContext('2d');
      cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);
      return page.render({ canvasContext: cx, viewport: v }).promise.then(function () {
        return c.toDataURL('image/png');
      });
    });

    var chrono = new Promise(function (_, rej) {
      setTimeout(function () { rej(new Error('delai depasse')); }, S.DELAI_MS);
    });
    return Promise.race([travail, chrono]);
  }
};
